import { cn } from '@/shadcn-ui/utils';
import { LoaderButton } from '@/common/components/loader-button';
import { PackageSummary } from '@/catalog/hooks/use-package-summary';
import { Skeleton } from '@/shadcn-ui/skeleton';
import { withPageContainerStyles } from '@/common/components/page-layout';
import Spacer from '@/common/components/spacer';
import * as gtag from '@/common/utils/gtags.client';
import EstimatedPricing from './estimated-pricing';

export interface PDPStickyBarProps {
  packageSummary?: PackageSummary | undefined;
  isLoading?: boolean;
  fullstoryContinueEventDelegate?: () => void;
  handleSavingsClick?: () => void;
}

export default function PDPStickyBar({
  packageSummary,
  isLoading,
  fullstoryContinueEventDelegate,
  handleSavingsClick,
}: PDPStickyBarProps) {
  const handleSubmitEvent = () => {
    gtag.event('vehicle_details_continue');
    fullstoryContinueEventDelegate?.();
  };

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 z-10 flex min-w-full translate-y-0 transform items-center justify-center bg-flexcar-neutral100 p-[16px] py-4 shadow-stickyBarShadow transition-transform duration-800 ease-in-out lg:hidden',
        {
          'translate-y-full': !packageSummary,
        }
      )}
    >
      <div
        className={withPageContainerStyles(
          'w-full max-w-[1440px] flex-row items-center justify-between gap-6 p-0'
        )}
      >
        <div className="flex flex-col">
          {isLoading ? (
            <>
              <Skeleton className="h-4 w-[220px]" />
              <Spacer variant="height8" />
              <Skeleton className="h-4 w-[200px] self-end" />
            </>
          ) : (
            <>
              <EstimatedPricing
                estimatedMonthlyCostCopy={packageSummary?.estimatedMonthlyCostCopy || ''}
                estimatedMonthlySavingsCopy={packageSummary?.estimatedSavingsCopy}
                onClickDelegate={handleSavingsClick}
              />
            </>
          )}
        </div>

        <LoaderButton
          type="submit"
          name="intent"
          value="plan-with-insurance"
          className="h-[48px] max-w-[280px] grow rounded-full px-[48px] py-[12px] ring-0 hover:bg-flexcar-neutral20 hover:ring-0 focus:ring-0 sm:min-w-[280px] sm:grow-0"
          disabled={isLoading}
          onClick={handleSubmitEvent}
        >
          Continue
        </LoaderButton>
      </div>
    </div>
  );
}
